export default __webpack_public_path__ + "static/En_ELIB_EzyMedical_Exclusion-cd2766be65e5a6c491b751b9942b0892.pdf";